module.exports = __webpack_public_path__ + "static/adi-logo-60337ab8b1e649fbd42224acf5ce5933.jpeg";